@if (headerConfig().backgroundImageWithFloatingText?.isNullOrEmpty() === false) {
  <lsa-background-image-with-floating-text
    [config]="headerConfig().backgroundImageWithFloatingText!"
  ></lsa-background-image-with-floating-text>
} @else {
  <lsa-carousel
    [autoRotateMs]="headerConfig().carousel!.autoRotateMs"
    [loop]="headerConfig().carousel!.loop ?? true"
    [slideCount]="headerConfig().carousel!.slides.length"
  >
    @for (slide of headerConfig().carousel!.slides; track $index) {
      @if (slide.backgroundImageWithFloatingText?.isNullOrEmpty() === false) {
        <div class="carousel-slide">
          <lsa-background-image-with-floating-text
            [config]="slide.backgroundImageWithFloatingText!"
          ></lsa-background-image-with-floating-text>
        </div>
      }
      @if(slide.verseOfTheDay?.isNullOrEmpty() === false) {
        <div class="carousel-slide">
          <lsa-verse-of-the-day
            [config]="slide.verseOfTheDay!"
          ></lsa-verse-of-the-day>
        </div>
      }
    }
  </lsa-carousel>
}
